import { Section } from '~/shared/section/Section';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import { GoalCard } from '../../goals/GoalCard';

export function SuggestedGoals() {
	const { suggestedGoalsAndInterventions, dispatchPredefinedGoalSelected } = useGoalsAndInterventionsWizard();
	if (suggestedGoalsAndInterventions.length === 0) {
		return (
			<div className="flex flex-col gap-4">
				<Section>
					<div className="text-center text-sm text-gray-500">No suggested goals for this visit</div>
				</Section>
			</div>
		);
	}
	return (
		<div className="flex flex-col space-y-16 px-1 py-2">
			<div className="flex flex-col space-y-4">
				{suggestedGoalsAndInterventions.map(x => {
					return (
						<GoalCard
							key={x.goalDefinition.id}
							title={x.goalDefinition.title}
							definitionText={x.goalDefinition.definitionText}
							onGoalSelect={() => dispatchPredefinedGoalSelected(x.goalDefinition)}
						/>
					);
				})}
			</div>
		</div>
	);
}
